module.exports = __webpack_public_path__ + "img/Docs3.6271d2d5.jpg";